export function liveModes(search) {
  const params = new URLSearchParams(search);
  return { localNetplay: params.get('games') !== 'streaming', viewMode: params.has('watch') || params.has('stream') ? 'watch' : 'play' };
}
